<template>
  <div>
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div> -->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <el-form
      :loading="loading"
      status-icon
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item
        v-for="(item, index) in detailLimitFiled"
        :key="index"
        :label="item.label ? item.label + ':' : ''"
        :prop="item.prop || ''"
      >
        <div v-if="item.img">
          <div
            class="img-group"
            v-if="item.str2Arr && data.formData[item.prop]"
          >
            <template v-if="typeof data.formData[item.prop] === 'string'">
              <template v-if="data.formData[item.prop].includes(',')">
                <div
                  v-for="(v, k) in data.formData[item.prop].split(',')"
                  :key="k"
                  class="img"
                >
                  <div class="index">{{ k + 1 }}</div>
                  <img
                    style="height: 200px;width: auto;margin-left:10px;"
                    :src="v"
                    alt
                  />
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v, k) in data.formData[item.prop].split(';')"
                  :key="k"
                  class="img"
                >
                  <div class="index">{{ k + 1 }}</div>
                  <img
                    style="height: 200px;width: auto;margin-left:10px;"
                    :src="v"
                    alt
                  />
                </div>
              </template>
            </template>
            <template v-else>
              <div
                v-for="(v, k) in (data.formData[item.prop] || []).filter(
                  r => r && r != 'null'
                )"
                :key="k"
                class="img"
              >
                <div class="index">{{ k + 1 }}</div>
                <img
                  style="height: 200px;width: auto;margin-left:10px;"
                  :src="v"
                  alt
                />
              </div>
            </template>
          </div>
          <img
            v-else
            style="height: 200px;width: auto"
            :src="data.formData[item.prop]"
            alt
          />
        </div>
        <div v-else-if="item.file">
          <div v-for="(t, i) in handleFiles(data.formData[item.prop])" :key="i">
            <a :href="t.src">{{ t.name }}</a>
          </div>
        </div>
        <div v-else-if="item.type === 'messageList'">
          <div v-for="(item, index) in item.formatter(data.formData, item)">
            <div class="digit-detail-link" @click="openWindow(item.url)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div v-else-if="item.type === 'time'">
          <div>{{ data.formData[item.prop] | formatDate }}</div>
        </div>
        <div v-else-if="item.type === 'iframe'">
          <div style="min-height: 500px">
            <iframe
              :src="item.formatter(data.formData, item)"
              @load="iframeLoad"
              class="iframe"
              ref="contract"
              style="object-fit :contain"
              width="300"
              :height="ifrHeight"
              frameborder="0"
            />
          </div>
        </div>
        <div v-else-if="item.formatter">
          {{ item.formatter(data.formData, item) }}
        </div>
        <div v-else>
          {{ data.formData[item.prop]
          }}{{ item.prop === 'visitMinute' ? '分钟' : '' }}
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import {objectFormat} from '@/tools/objectFormat.js'
import { btLoading } from '@/Mixin/btLoading';
import { formatDate } from '@/tools';
import config from '@/config/index';
export default {
  name: 'digitDetail',
  mixins: [btLoading],
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          formData: {},
          type: 1
        };
      }
    }
  },
  filters: {
    formatDate(val) {
      return formatDate(val, 'Y-M-D h:m');
    }
  },
  computed: {
    detailLimitFiled() {
      let { type = 1 } = this.data.formData;
      let list = this.detailLimit;
      return list.filter(r => {
        let forUse = r.use;
        if (Array.isArray(forUse)) {
          return forUse.includes(type);
        } else {
          return true;
        }
      });
    }
  },
  data() {
    return {
      loading: true, // 表单 loading
      formLabelWidth: '120px',
      detailLimit: [
        {
          label: '项目参与人',
          prop: 'fullName'
        },
        {
          label: '手机号',
          prop: 'phone'
        },
        {
          label: '客户名称',
          prop: 'customerName'
        },
        {
          label: '职称',
          use: [1],
          prop: 'dutyName'
        },
        {
          label: '职务',
          use: [3],
          prop: 'dutyName',
          formatter(row, col) {
            // "pharmacyPeopleDuty|1:店长|2:副店长|3:店员|4:业务员|5:采购|其他"
            let key = row.pharmacyPeopleDuty;
            let list = {
              1: '店长',
              2: '副店长',
              3: '店员',
              4: '业务员',
              5: '采购'
            };
            return list[key] || '其他';
          }
        },
        {
          label: '医院名称',
          use: [1],
          prop: 'hospitalName'
        },
        {
          label: '医院等级',
          use: [1],
          prop: 'gradeName'
        },
        {
          //todo
          label: '科室名称',
          use: [1],
          prop: 'departmentName'
        },
        // 1 医疗机构名称
        // 2 医疗机构类别
        {
          label: '医疗机构地区',
          use: [2],
          prop: 'hospitalName',
          formatter(row, col) {
            let {
              provinceName = '无',
              cityName = '无',
              districtName = '无'
            } = row;
            return `${provinceName}/${cityName}/${districtName}`;
          }
        },
        {
          label: '医疗机构名称',
          use: [2],
          prop: 'hospitalName'
        },
        {
          label: '医疗机构类别',
          use: [2],
          prop: 'gradeName'
        },
        // 1 药店名称
        // 2 省市区
        // 3 地址
        {
          label: '药店名称',
          use: [3],
          prop: 'pharmacyName'
        },
        {
          label: '省市区',
          use: [3],
          prop: 'gradeName',
          // 省(provinceName)，市（cityName），区（districtName）
          formatter(row, col) {
            let {
              provinceName = '无',
              cityName = '无',
              districtName = '无'
            } = row;
            return `${provinceName} ${cityName} ${districtName}`;
          }
        },
        {
          label: '地址',
          use: [3],
          prop: 'address'
        },
        {
          //todo 1为微信
          label: '数字拜访途径',
          prop: 'visitType',
          formatter: function(row, col) {
            let target = row[col.prop];
            return target == 1 ? '微信' : '';
          }
        },
        {
          label: '拜访时间',
          prop: 'visitTime',
          type: 'time'
        },
        {
          label: '客户反馈时间',
          prop: 'feedbackDt',
          type: 'time'
        },
        {
          label: '客户反馈',
          prop: 'feedbackContent'
        },
        {
          label: '传递信息',
          prop: 'customerName',
          type: 'messageList',
          formatter: function(row, col) {
            let titles = row.informationNames;
            let ids = row.channelIds;
            let infoIds = row.informationIds;
            let joinInfo = [];
            if (Array.isArray(titles) && titles.length > 0) {
              titles.forEach((r, index) => {
                joinInfo.push({
                  title: r,
                  id: ids[index] || '',
                  infoId: infoIds[index] || '',
                  url: `${
                    config.webViewUrl
                  }/html/index.html#/visit?id=${row.id || ''}&platform=oss`
                });
              });
            }
            return joinInfo;
          }
        },
        {
          label: '信息反馈记录',
          prop: 'customerName',
          type: 'iframe',
          formatter: function(row) {
            let { id } = row;
            return `${config.webViewUrl}/html/index.html#/visit?id=${id}&showType=feedback&platform=oss`;
          }
        },
        {
          label: '信息转发记录',
          prop: 'customerName',
          type: 'iframe',
          formatter: function(row) {
            let { id } = row;
            return `${config.webViewUrl}/html/index.html#/visitDetail?id=${id}&platform=oss`;
          }
        }
      ],
      ifrHeight: '500px'
    };
  },
  watch: {},
  methods: {
    iframeLoad() {
      this.$nextTick(_ => {
        let ifrDoms = document.getElementsByClassName('iframe')[0];
        let ifrDom = null;
        if (ifrDoms.length > 0) {
          ifrDom = ifrDoms[0];
        } else {
          return;
        }
        setTimeout(_ => {
          this.ifrHeight =
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        }, 1500);
      });
    },
    openWindow(url) {
      window.open(
        url,
        'newwindow',
        'height=600,left=100,top=70,width=400,location=no,locationbar=no,status=yes,resizable=yes,scrollbars=yes'
      );
    },
    close() {
      this.$router.back();
      this.$parent.hideDetail();
    },
    handleFiles(str) {
      let list = [];
      if (!str || !this.data.formData.bingliFileName) {
        return list;
      }
      let nameList = this.data.formData.bingliFileName.split(',');
      let strList = str.split(',');
      for (let i = 0; i < strList.length; i++) {
        list.push({ src: strList[i], name: nameList[i] });
      }
      return list;
    },
    eventClose() {
      // 关闭窗口
      this.$emit('update:showUserAddEdit', false); // 逆向修改
    }
    //提交
  },
  created() {
    // console.log(this.data, '这里要获取name进行过率');
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
  height: 2em;
}

.img-group .img {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.img-group .img .index {
  margin-right: 15px;
}
.digit-detail-link {
  color: #00abe4;
  &::before {
    $size: 0.7em;
    content: ' ';
    display: inline-block;
    margin-right: $size;
    height: $size;
    width: $size;
    border-radius: 50%;
    background: #00abe4;
  }
}
</style>
